import React, { useState } from 'react';
import HyperLink from 'components/Core/HyperLink';
import { STLogo } from 'components/Brand/Logos/STLogo';
import { STGlyphTertiary } from 'components/Brand/Logos/STGlyph';
import SwiftyForm2 from 'components/Form/SwiftyForm/v2';
import closeIcon from '../images/close-icon.svg';
import { SingleStepFormContainer, FullModalContainer } from './styles';
import './modal-responsive.less';

const SingleStepForm = (props) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [showBackBtn, setShowBackBtn] = useState(false);

  const onStepChange = (data, step) => {
    setCurrentStep(step);
  };

  const onSetValues = (data, step) => {
    if (step === 0) {
      setShowBackBtn(
        data.Primary_Industry__c === 'Roofing' || data.Primary_Industry__c === 'Other',
      );
    }
  };

  return (
    <FullModalContainer>
      <div className="full-modal-header--wrapper">
        {(showBackBtn || currentStep > 0) && <div className="w-[30px] h-[30px] sm:hidden" />}
        <div className="full-modal-header--logo">
          <HyperLink href="/">
            <STLogo className="w-[160px] h-[30px] hidden xl:block" variation="black" />
            <STGlyphTertiary className="w-[30px] h-[30px] xl:hidden" />
          </HyperLink>
        </div>
        <div className={`single-step-form--progress-container`}>
          <div
            className={`single-step-form--progress`}
            style={{ width: `${(currentStep + 1) * 20}%` }}
          />
        </div>
        <div className={`single-step-form--close-container`} onClick={props.closeModal}>
          <img className="close-modal-button" src={closeIcon} />
        </div>
      </div>
      <SingleStepFormContainer
        className={`single-step-form--container single-step-form--step-${currentStep}`}
        currentStep={currentStep}
      >
        <SwiftyForm2
          dataPosition="Modal - ST53 Single Step Form"
          {...props}
          titleSize="28px"
          formType="multi_step_demo"
          onStepChange={onStepChange}
          onSetValues={onSetValues}
          isSingleStepForm
        />
      </SingleStepFormContainer>
    </FullModalContainer>
  );
};

export default SingleStepForm;
